export default {
  name: "Language",
  selection: "System Language Selection",
  english: "English",
  simplified_chinese: "中文（简体）",
  traditional_chinese: "中文（繁体）",
  vietnamese: "Tiếng Việt",
  thai: "ไทย",
  indonesian: "Bahasa Indonesia",
  malay: "Melayu",
  japanese: "日本",
  korean: "한국어",
  native: {
    english: "English",
    simplified_chinese: "Chinese (CN)",
    traditional_chinese: "Chinese (TW)",
    vietnamese: "Vietnamese",
    thai: "Thai",
    indonesian: "Indonesian",
    malay: "Malay",
    japanese: "Japanese",
    korean: "Korean"
  }
};
